/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputeJob,
  ComputeJob$inboundSchema,
  ComputeJob$Outbound,
  ComputeJob$outboundSchema,
} from "./computejob.js";

export type ComputeJobList = {
  nextCursor: string | null;
  total: number;
  data: Array<ComputeJob>;
};

/** @internal */
export const ComputeJobList$inboundSchema: z.ZodType<
  ComputeJobList,
  z.ZodTypeDef,
  unknown
> = z.object({
  next_cursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeJob$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "next_cursor": "nextCursor",
  });
});
/** @internal */
export type ComputeJobList$Outbound = {
  next_cursor: string | null;
  total: number;
  data: Array<ComputeJob$Outbound>;
};

/** @internal */
export const ComputeJobList$outboundSchema: z.ZodType<
  ComputeJobList$Outbound,
  z.ZodTypeDef,
  ComputeJobList
> = z.object({
  nextCursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeJob$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    nextCursor: "next_cursor",
  });
});

export function computeJobListToJSON(computeJobList: ComputeJobList): string {
  return JSON.stringify(ComputeJobList$outboundSchema.parse(computeJobList));
}
export function computeJobListFromJSON(
  jsonString: string,
): SafeParseResult<ComputeJobList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeJobList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeJobList' from JSON`,
  );
}
